import styled from 'styled-components';
import { PropertyCardPhotoFooterMixin } from '../../mixins/components/PropertyCardPhotoFooterMixin';
export var StyledPropertyCardPhotoFooter = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledPropertyCardPhotoFooter",
  componentId: "c11n-8-111-1__sc-12lm4o3-0"
})(["", ""], PropertyCardPhotoFooterMixin);